import { render, staticRenderFns } from "./formAllTask.vue?vue&type=template&id=a516cf8a&"
import script from "./formAllTask.vue?vue&type=script&lang=js&"
export * from "./formAllTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports